import { render, staticRenderFns } from "./XFilterSearch.vue?vue&type=template&id=679b3c81"
import script from "./XFilterSearch.vue?vue&type=script&lang=js"
export * from "./XFilterSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports